import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../apis/api';
import style from './style/Signupstyle.module.css';
import { CreateCaptcha } from '../functions/captcha';


const PlaceOrder = () => {
    const history = useHistory();
    const location = useLocation();
    const [code,setCode] = useState('');
    const [message,setMessage] = useState('');

    const Submit = async (e) =>{
        e.preventDefault();
        let x  = document.getElementById('validate').value;
        console.log(x);
        if(x === code){
            try {
                const response = await api.post('/placeorder',{
                    order:location.state.order,
                    address:location.state.address,
                    totalAmount:location.state.totalAmount
                });
                const data = await response.data.orderid;
                console.log(data);
                history.push('/Sucessfully-placed',data);
            } catch (error) {
                console.log(error);
            }
        }else{
            // console.log("Invalid catpa");
            setMessage('Invalid Entry');
        }
    }
    useEffect(()=>{
        let x = CreateCaptcha('catchpa');
        setCode(x);
    },[]);

    return (
        <>
         <section className={style.body}>
                <div className={style.form} style={{ margin: '40px auto' }}>
                    <h1 style={{ textAlign: 'center' }}>Enter below Image to validate</h1>
                    <p id="msg" style={{ textAlign: 'center', color:'red' }}>{message}</p>
                    <form>
                        <div className={style.formlabel} style={{textAlign:'center'}} id='catchpa'>
                            
                        </div>
                        <div className={style.formlabel}>
                           <input type="text" placeholder="Enter the Catcpa" id="validate"/>
                        </div>
                        <button onClick={Submit}>Submit</button>
                    </form>
                </div>
            </section>
        </>
    )
}

export default PlaceOrder;
